import {
  listUserJoinOrg,
  bindOrgId,
  getUserIsJoinTypeV30
} from "@/api/user/listUserJoinOrg.js";
import { setOrgInfo, setOrgId } from "@/utils/common.js";
import { obj2StrParams } from "@/utils/common.js";

// 绑定机构
export const handleBindOrgId = org => {
  bindOrgId({ orgId: org.id })
    .then(res => {
      if (res) {
        setOrgInfo(org);
        setOrgId(org.id);
        window.location.href = "./index.html";
      }
    })
    .catch(() => {});
};
// 判断是否加入机构
// type = 1 已经加入  ||  type = 0 看  applyType 0未邀请 1已经申请
export const handleGetUserIsJoinTypeV30 = org => {
  getUserIsJoinTypeV30({ id: org.id })
    .then(res => {
      if (res.type === 1) {
        handleBindOrgId(org);
      } else if (res.type === 0) {
        if (res.applyType === 1) {
          let params = obj2StrParams({
            state: "1", // 1一个机构，0多个机构，多个机构会跳转listUserJoinOrg.html
            id: org.id,
            orgName: encodeURI(org.orgName)
          });
          window.location.href = "./inReview.html" + params;
        } else if (res.applyType === 0) {
          window.location.href = "./uninvited.html";
        }
      }
    })
    .catch(() => {});
};
export const orgInfo = [];
export const handleListUserJoinOrg = () => {
  listUserJoinOrg()
    .then(res => {
      switch (res.length) {
        case 0:
          window.location.href = "./uninvited.html";
          break;
        case 1:
          handleGetUserIsJoinTypeV30(res[0]);
          break;
        default:
          orgInfo.push(...res);
          window.location.href = "./listUserJoinOrg.html";
          break;
      }
    })
    .catch(() => {});
};
